import { Navigate, Route, Routes } from 'react-router-dom';
import AddEmployeePage from '../../../Pages/AdminAccount/EmployeesAdmin/AddEmployeePage';
import EmployeeDetailsPage from '../../../Pages/AdminAccount/EmployeesAdmin/EmployeeDetailsPage';
import EmployeesAdminPage from '../../../Pages/AdminAccount/EmployeesAdmin/EmployeesAdminPage';
import { FileImportsRoutes } from './FileImports';

export const EmployeeAdminRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<EmployeesAdminPage />} />
      <Route path="add-employee" element={<AddEmployeePage />} />
      <Route
        path="employee-details/:employeeId"
        element={<EmployeeDetailsPage />}
      />
      <Route path="import-files/*" element={<FileImportsRoutes />} />
      <Route path="*" element={<Navigate to="/*" />} />
    </Routes>
  );
};
